"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionResultsOpenEnded = void 0;
const client_shared_1 = require("@teams/client-shared");
const adaptivecards_1 = require("adaptivecards");
const UserDiscourseItem_1 = require("../../_shared/components/UserDiscourseItem");
const CardHelper_1 = require("../../_shared/utils/CardHelper");
const surveyHelpers_1 = require("../utils/surveyHelpers");
const QuestionResultsOpenEnded = (userSurveyResponses, question, autolinkIntegrations, maxResponsesCount) => {
    const itemListContainer = CardHelper_1.CardHelper.create(adaptivecards_1.Container, {
        separator: true,
        spacing: adaptivecards_1.Spacing.Large,
    });
    //Check if there are any responses yet
    if (!userSurveyResponses.some(r => r.responses.some(q => q.questionId === question.id))) {
        itemListContainer.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
            text: "No responses yet",
            horizontalAlignment: adaptivecards_1.HorizontalAlignment.Center,
            color: adaptivecards_1.TextColor.Accent,
            size: adaptivecards_1.TextSize.Medium,
        }));
        return itemListContainer;
    }
    // build list of open ended response UI components
    let sorted = userSurveyResponses.sort(surveyHelpers_1.surveyResponseSort);
    if (maxResponsesCount !== undefined) {
        sorted = sorted.slice(0, maxResponsesCount);
    }
    sorted.forEach(userResponse => {
        const userQuestionResponse = userResponse.responses.find(q => q.questionId === question.id);
        if (userQuestionResponse) {
            const autolinkResponse = (0, client_shared_1.applyAutolinkIntegrationsToTextAsMarkdown)(autolinkIntegrations, userQuestionResponse.value);
            const commentItem = {
                name: userResponse.user.name,
                comment: autolinkResponse,
                timestamp: userQuestionResponse.updatedAt || userQuestionResponse.createdAt,
            };
            const itemContainer = (0, UserDiscourseItem_1.UserDiscourseItem)(commentItem, question.contentType);
            itemListContainer.addItem(itemContainer);
        }
    });
    return itemListContainer;
};
exports.QuestionResultsOpenEnded = QuestionResultsOpenEnded;
//# sourceMappingURL=QuestionResultsOpenEnded.js.map